// import React, { useState } from 'react';
import React, { useEffect } from "react";
import BillAuditContent from "./BillAudit/BillAuditContent";
import { useLocation } from "react-router-dom";
// import BillHighlightsContent from './BillHighlights/BillHighlightsContent';

function BillManagerContent() {
  const location = useLocation();

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_location: "/costOfService/billManager",
      page_title: "Bill Audit",
    });
  }, [location]);

  // const [tabStates, setTabStates] = useState({
  //     tabBillHighlights: true,
  //     tabBillAudit: false
  // });

  // function toggleTabs(menuName) {
  //     console.log(menuName);
  //     setTabStates(prevState => {
  //         const updatedStates = {};
  //         for (const key in prevState) {
  //             updatedStates[key] = key === menuName ? !prevState[key] : false;
  //         }
  //         return updatedStates;
  //     });
  // }

  return (
    <>
      <h2>Bill Audit</h2>
      {/* <ul className="nav nav-tabs">
                <li><button onClick={() => toggleTabs('tabBillHighlights')} className={`tab btn btn-toggle d-inline-flex align-items-center rounded ${tabStates.tabBillHighlights ? ' active' : ''}`}>Bill Highlights</button></li>
                <li><button onClick={() => toggleTabs('tabBillAudit')} className={`tab btn btn-toggle d-inline-flex align-items-center rounded ${tabStates.tabBillAudit ? ' active' : ''}`}>Bill Audit</button></li>
            </ul>
            <div className="tab-content">
                <div className={`tab-pane${tabStates.tabBillHighlights ? ' active' : ''}`} id="BillHighlights">
                    <BillHighlightsContent />
                </div>
                <div className={`tab-pane${tabStates.tabBillAudit ? ' active' : ''}`} id="BillAudit">
                    <BillAuditContent />
                </div>
            </div> */}
      <BillAuditContent />
    </>
  );
}

export default BillManagerContent;
